<template>
  <div class="container-fluid mt-4 px-1">
    <div class="row gx-3"> 


      <div class="col-md-4">
        <div class="card shadow-sm p-4 h-100">
              <div class="col-md-6">
                <h6 class="pb-4 mb-0">품질검사</h6>
              </div>
          <form @submit.prevent="submitEvent">
            <!-- 원재료 선택 -->
            <div class="mb-3">
              <label for="epc" class="form-label">제품 선택</label>
              <input type="text" class="form-control" v-model="epc">
            </div>

            <!-- 스캔장소 (readPoint) -->
            <div class="mb-3">
              <label for="readPoint" class="form-label">스캔장소 (readPoint)</label>
              <select v-model="form.readPoint.manualURI" class="form-select" id="readPoint">
                <option value="">선택</option>
                <option v-for="item in readPointList" :key="item.id" :value="item.urn">
                  {{ item.name + ' ( ' + item.urn + ' )'}}
                </option>
              </select>
            </div>

            <!-- 입고장소 (bizLocation) -->
            <div class="mb-3">
              <label for="bizLocation" class="form-label">검사장소 (bizLocation)</label>
              <select v-model="form.bizLocation.manualURI" class="form-select" id="bizLocation">
                <option value="">선택</option>
                <option v-for="item in bizLocationList" :key="item.id" :value="item.urn">
                  {{ item.name + ' ( ' + item.urn + ' )'}}
                </option>
              </select>
            </div>

            <!-- 수량 -->
            <div class="mb-3">
              <label for="eventTime" class="form-label">이벤트 발생 시간</label>
              <input type="datetime-local" v-model="eventTimeTemp" class="form-control" id="eventTime" />
            </div>
            <div class="text-end">
              <button type="submit" class="btn btn-success">이벤트 등록</button>
            </div>

          </form>
        </div>
      </div>

      
      <div class="col-md-4">
        <div class="card shadow-sm p-4">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0">결과</h6>
          </div>
          <div class="selected-list"  style="height: 510px;">
            <template v-if="resultList.length">
              <ul class="list-unstyled mb-0">
                <li v-for="it in resultList" :key="it" class="sel-item">
                  <div class="urn-line">{{ it }}</div>
                </li>
              </ul>
            </template>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { fetchBizLocationData, fetchReadPointData, fetchProductData } from "../../api/common/initDataAPI";
import { pollEpcisEvent, saveBlockChain } from "@/api/common/blockchain.js";
import api from '@/api/api';

export default {
  name: "EventPrc4",
  components: {
  },
  inject: ['showLoading', 'hideLoading'],
  computed: {
    mfId() {
      return this.$store.getters['UserStore/getMfId'];
    },
  },
  watch: {
    'form.readPoint.manualURI'(urn) {
      const sel = this.readPointList.find(r => r.urn === urn);
      if (sel && sel.blId != null) {
        const blId = sel.blId;
        if(blId){
          const selBlId = this.bizLocationList.find(b => b.id === blId);
          if(selBlId) this.form.bizLocation.manualURI = selBlId.urn;
        }
      }
    },
  },
  data() {
    return {
      loadingEvents: true,
      epc: '',
      crtEventID: '',  
      eventTimeTemp: '',
      form: {
        parentID: '',
        childEPCs: [],
        eventType: "ObjectEvent",
        action: 'ADD',
        businessStep: 'INSPECTING',
        disposition: 'ACTIVE',
        eventTimeSelector: '',
        eventTime: {},
        quantity: '1',
        epcList: [],
        readpointselector: 'manually',
        readPoint: {
          gcpLength: null,
          manualURI: "",
        },
        businesslocationselector: "manually",
        bizLocation: {
          gcpLength: null,
          manualURI: "",
        },
        vocabularySyntax: 'URN',
        ordinaryEvent: true,
        RecordTimeOption: 'no',
        recordTimeType: 'SAME_AS_EVENT_TIME',
        PersistentDispositionType: null,
        PersistentDisposition: null,
        persistentDispositionCount: 0,
        persistentDispositionList: [],
        businessTransactionCount: 0,
        businessTransactionList: [],
        errorCorrectiveCount: 0,
        errorCorrectiveIdsList: [],
        eventID: false,
        eventIdType: 'UUID',
        hashAlgorithm: 'sha-256',
      },
      productList: [],
      bizLocationList: [],
      readPointList: [],
      resultList: [],
    }
  },
  async mounted() {
    //this.eventTimeTemp = this.setDefaultTime();
    this.eventTimeTemp = '2025-07-13T14:17';

    let now = new Date()
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset())
    now.setSeconds(now.getSeconds(), 0)
    now = now.toISOString().slice(0, -1)

    this.form.eventTime = {
      specificTime: now,
      fromTime: now,
      toTime: now,
      timeZoneOffset: '+09:00'
    }

    const [bizList, readList, prdList] = await Promise.all([
      fetchBizLocationData(this.mfId),
      fetchReadPointData(this.mfId, 'Y'),
      fetchProductData(this.mfId),
    ]);
    this.bizLocationList = bizList;
    this.readPointList   = readList;
    this.productList = prdList;

  },
  methods: {
   async submitEvent() {
      this.$store.state.DesignTestDataStore.eventType = "ObjectEvent";
      this.form.eventTime = this.syncEventTimeFromTemp(this.eventTimeTemp);
      this.showLoading?.('이벤트를 EPCIS에 저장중...');
      try {
        this.form.epcList = [this.epc];

        // 1) Vuex로 캡처 JSON 생성
        this.$store.dispatch('TestDataJsonPreparator/jsonPreparation', { formData: this.form });
        this.$store.commit(
          'TestDataGeneratorStore/populateTestDataInput',
          JSON.stringify(this.$store.state.TestDataJsonPreparator.testDataInputTemplate)
        );
        await this.$store.dispatch('TestDataGeneratorStore/testdataGenerator');
        const dataResult = JSON.stringify(this.$store.state.TestDataGeneratorStore.testDataOutput, null, 2);

        // 2) EPCIS 캡처
        const cap = await this.captureApi(dataResult);
        if (!cap.success) throw new Error(cap.error || 'EPCIS 캡처 실패');

        this.showLoading?.('이벤트를 블록체인에 저장중...');
        // ✅ 공통 유틸 사용 (EPCIS → 블록체인)
        const committedEvent = await pollEpcisEvent(this.crtEventID, {
          timeout: 60000, startInterval: 800, maxInterval: 4000
        });
        await saveBlockChain(this.crtEventID, committedEvent, 60000);
        this.resultList.push(committedEvent.epcisBody.queryResults.resultsBody.eventList[0].epcList[0]);
        this.toastSuccess?.("저장 되었습니다.");
      } catch (e) {
        console.error(e);
        this.toastError?.(e.message || '처리 중 오류가 발생했습니다.');
      } finally {
        this.hideLoading?.();
      }
    },

    // ✅ EPCIS 캡처: eventID 생성/보관 포함
    async captureApi(dataResult) {
      try {
        const jsonData = JSON.parse(dataResult);
        const event = jsonData.epcisBody.eventList[0];

        // 회사 prefix
        if (this.mfId) {
          event["cbv:extension"] = { ...(event["cbv:extension"] || {}), companyPrefix: this.mfId };
        }
        // EPC 리스트
        event.epcList = this.form.epcList;

        // 사용 안 함
        delete event.parentID;
        delete event.childEPCs;

        // eventID 없으면 생성
        if (!event.eventID) {
          const id = (crypto?.randomUUID?.() || (Date.now().toString(36) + Math.random().toString(36).slice(2)));
          this.crtEventID = `urn:uuid:${id}`;
          event.eventID = this.crtEventID;
        } else {
          this.crtEventID = event.eventID;
        }

        const resp = await fetch(`/api/epcisAPI/capture`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(jsonData),
        });
        if (!resp.ok) throw new Error("응답 오류: " + resp.status);

        const text = await resp.text();
        const result = text ? JSON.parse(text) : {};
        return { success: true, data: result };
      } catch (e) {
        console.error('전송 실패:', e);
        return { success: false, error: e.message || e };
      }
    },
    async fromStep1(list) {
      this.resultList = [];
      const delay = (ms) => new Promise(r => setTimeout(r, ms));
      for (let data of list) {
        this.epc = data;
        await this.submitEvent();
        await delay(3000);
      }

      return this.resultList;
    },
  },
};
</script>
